<template>
    <v-dialog ref="dialog" v-model="modal" persistent :max-width="maxWidth">
        <template v-slot:activator="{  }">
            <v-text-field class="search-activator" :label="label" v-model="pickupText" readonly
                :append-icon="appendIcon"
                :append-outer-icon="removeIcon"
                @click:append="modal = true"
                @click:append-outer="remove"
                :rules="getRules"      
                :messages="messages"></v-text-field>
        </template>

        <v-card>         
            <v-card-title>
                <span class="headline">{{title}}</span>
            </v-card-title>

            <v-card-text>
                <v-container py-0>
                    <v-layout wrap>
                        <v-row v-show="showSearch" align="center" justify="center">
                            <v-col cols="10">
                                <v-form ref="form">
                                    <slot></slot>
                                </v-form>                                
                            </v-col>
                            <v-col cols="2">
                                <v-btn class="success" @click="btnSearch_OnClick">{{search}}</v-btn>                                                             
                            </v-col>
                        </v-row>   

                        <v-row v-show="!showSearch">
                            <v-col cols="3">
                                <slot></slot>
                            </v-col>
                            <v-col cols="9">
                                <v-text-field
                                    v-model="searchText"
                                    append-icon="mdi-magnify"
                                    :label="search"
                                    single-line
                                    hide-details
                                ></v-text-field>                                                           
                            </v-col>
                        </v-row>                                  
                    </v-layout>
                </v-container>
                <br/>

                <v-data-table 
                    :loading="showLoader"
                    :loading-text="loadingText"
                    no-data-text="Sem resultados"
                    :headers="getColumns" 
                    :items="datasource" 
                    :items-per-page="5" 
                    :single-select="!multiSelect"
                    :footer-props="dataFooter"
                    v-model="possibleSelections"
                    :search="searchText"
                    @click:row="dataTable_RowClick"
                    :item-key="itemKey"
                    show-select>    
                </v-data-table>                
            </v-card-text> 

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="danger" @click="modal = false">{{cancel}}</v-btn>                             
                <v-btn v-show="possibleSelections.length > 0" color="success" @click="btnConfirm_OnClick">{{confirm}}</v-btn>
            </v-card-actions>
        </v-card>  
    </v-dialog>  
</template>

<script>
import FormMixin from '@/mixin/form'

export default {
    name: "pick-list", 
    mixins: [ FormMixin ],  
    props:{
        search_OnClick:{
            required: false, 
            type: Function
        },
        formatSelection:{
            required: false, 
            type: Function
        },  
        required:{
            required: false, 
            default: false,
            type: Boolean   
        }, 
        rules:{
            required: false, 
            type: Array 
        },
        readonly:{
            required: false, 
            default: false,
            type: Boolean   
        }, 
        hint:{
            required: false, 
            type: String          
        },                     
        maxWidth:{
            required: false, 
            default: "1000px",
            type: String          
        },
        title:{
            required: true, 
            type: String
        },
        multiSelect: {
            required: false,
            default: false,
            type: Boolean
        },
        columns:{
            required: true, 
            type: Array
        },
        label:{
            required: true, 
            type: String
        },
        itemKey:{
            required: true, 
            type: [String, Number, Date]
        },
        value:{
            required: false,
            type: [Array, Object]
        }
    },
    watch:{
        value(newValue){
            this.checked = [];
            this.checked.push(newValue);
        },
        hint(newValue){
            this.message = newValue;
        }
    },  
    data(){
        return {
            data: [],
            modal: false, 
            checked: [],
            possibleSelections: [],
            searchText: null,
            showLoader: false,
            message: null
        }
    },
    computed: {  
        cancel () {
            return this.$t("Common.cancel");
        },
        clear () {
            return this.$t("Common.clear");
        },        
        confirm () {
            return this.$t("Common.confirm");
        }, 
        loadingText () {
            return this.$t("Common.loading");
        },           
        selectedDate(){
            if(this.date == null) return null;
            return this.$moment(this.date).format('L'); 
        },
        datasource(){
            let datasource = [];

            if(this.data != null && this.data != undefined)
                datasource = this.data;

            return datasource;
        },
        getColumns(){
            let columns = [];

            if(this.columns != undefined && this.columns != null){
                columns = this.columns;
            }

            return columns;           
        },   
        appendIcon(){
            return this.readonly ? null :  "mdi-database-search";
        },
        removeIcon(){
            if(this.readonly) 
                return null;

            if((this.checked || []).length > 0)
                return "mdi-close";
            
            return null;
        },
        pickupText: {
            get(){
                if(!this.multiSelect == true){
                    if((this.checked || []).length > 0){
                        if(this.formatSelection != undefined && this.formatSelection != null){
                            return this.formatSelection(this.checked[0]);
                        }
                        else{
                            return this.checked[0][this.itemKey];
                        }
                    }
                }

                return null;
            },
            set(){

            }
        },
        showSearch(){
            if(this.$slots == undefined || this.$slots.default == undefined) return false;
            return this.$slots.default.length > 0;
        },
        messages(){
            if(this.message == undefined || this.message == null)
                return "";

            return this.message;
        },
        getRules(){
            if((this.rules || []).length > 0){
                return this.rules;
            }
            else{
                if(this.required == true){
                    return [
                        val => {
                            if((val || null) == null)
                                return this.$t("Common.mandatory-field");

                            return true;
                        }
                    ];
                }
            }

            return [];
        }   
    },    
    methods:{     
        remove(){
            this.message = "";
            this.checked = [];

            this.possibleSelections = [];
            this.$emit("input", null);
        },
        dataTable_RowClick(row){
            const self = this;
            let index = self.$_.find(self.data, (r) => r[self.itemKey] === row[self.itemKey]); 
            if(index >= 0) 
                this.possibleSelections.slice(index, 1);            

            else{
                if(!this.multiSelect == true)
                    this.possibleSelections = [];

                this.possibleSelections.push(row);
            }
        },
        async btnConfirm_OnClick(){
            let result = null;
            if(this.multiSelect == true)
                result = this.possibleSelections;

            else {
                if((this.possibleSelections || []).length > 0)
                    result = this.possibleSelections[0];
            }

            this.checked = this.possibleSelections;
            this.$emit("input", result);
            this.modal = false;
        },   
        async btnSearch_OnClick(){
            if(this.$refs.form.validate()){
                if(this.search_OnClick != undefined && this.search_OnClick != null){
                    this.showLoader = true;
                    this.data = await this.search_OnClick();
                    this.showLoader = false;
                }                
            }
        }         
    }
}
</script>

<style lang="scss">
@import "../../styles/material-dashboard/variables";

.picklist{
    background-color: $white !important;
}

// .search-activator{
//     .v-input__control{
//         .v-input__append-inner{
//             i{
//                 color: $brand-primary !important; 
//             }
//         }
//     }
//     .v-input__append-outer{
//         i{
//             color: $brand-danger !important; 
//         }
//     }
// }

.v-data-table{
    tbody{
        tr:hover{
            cursor: pointer;
        }
    }
}
</style>
